import React, { useState, useEffect, useLayoutEffect } from "react";
import { Modal } from "react-bootstrap";

import Loader from "react-loader-spinner";
import ModalContent from '../elements/SliderItem/ModalContent';
import { setCloseModal } from '../store/actions';

import Header from "./Main/Header";
import Tabs from "./Main/Tabs";
import Table from "./Main/Table";
import Accordion from "../elements/Acordion";
import Support from "./Main/Support";
import Error from "./Main/Error";
import { useSelector, useDispatch } from "react-redux"

import { eventsRequests } from "../Utils/Api";
import "bootstrap/dist/css/bootstrap.min.css";

const SubscribersBoard = props => {
  const [bloggerData, getBloggerData] = useState();
  const [loading, setLoading] = useState(true);

  const [menu, setMenuItem] = useState("game");

  let [width, setWidth] = useState(window.innerWidth);

  const [error, setError] = useState(false);

  const { modalIsOpen, content } = useSelector(store => store.modal)
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    const updateWidth = () => setWidth(window.innerWidth);

    window.addEventListener("resize", updateWidth);

    updateWidth();
  });

  useEffect(() => {
    const url = window.location.pathname.split("/");
    // const url = '/page/mariya'.split("/");
    // const url = '/page/al2ex_'.split("/");
    // const url = '/page/sub2by'.split("/");
    // const url ='/page/instatest8101'.split("/")
    // const url ='page/luxemebel_'.split("/")
    eventsRequests
      .getBloggerData(url[url.length - 1])
      .then(data => {
        getBloggerData(data.data);
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        props.is404(true);
        setLoading(false);
      });
  }, []);

  const closeModal = () => dispatch(setCloseModal());

  if (!loading) {
    if (!error) {
      return (
        <div>
          <Modal
              show={modalIsOpen}
              onHide={closeModal}
              centered
          >
          <ModalContent content={content} closeModal={closeModal} width={width}/>
          </Modal>
          <div className="board_container">
            <Header bloggerData={bloggerData} setMenuItem={setMenuItem} menu={menu} width={width} />

            <div className="right-wrapper">
              {menu === "game" ? (
                <div className="tAndTContainer">
                  <Tabs bloggerData={bloggerData} width={width} />
                  <Table bloggerData={bloggerData} />
                </div>
              ) : menu === "faq" ? (
                <Accordion width={width} />
              ) : (
                <Support />
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="error_container">
          <Error />
        </div>
      );
    }
  } else {
    return (
      <div className="board_loader">
        <Loader type="Oval" color={window.innerWidth <= 1224 ? "#ffffff" : "#7ac479"} height={60} width={60} />
      </div>
    );
  }
};

export default SubscribersBoard;
